module.exports = __webpack_public_path__ + "82720b79c557c1fd61d814a2f36667a2.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-group/accounts/group-accounts.html
// module id = 1792
// module chunks = 0